module.exports = __webpack_public_path__ + "img/BSD-alt.b3b18e18.svg";